import { Grid, Box, Typography } from "@mui/material";
import { getColorMapCalendar } from "../../organisms/project-calendar/helper";

export default function ColorInfo() {
  const colorMap = getColorMapCalendar();

  return (
    <Grid container spacing={1}>
      {Object.entries(colorMap).map(([label, color]) => (
        <Grid item xs={6} key={label}>
          <Box display="flex" alignItems="center" gap={1}>
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                backgroundColor: color,
                flexShrink: 0,
              }}
            />
            <Typography fontSize={"12px"}>{label}</Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
}
